// extracted by mini-css-extract-plugin
export default {"auth":"styles_auth__P1qFC","right":"styles_right__QogoP"};